// @flow

export type SEOPageType = {
  slug: () => string,
  title: (str?: string, ...params: Array<any>) => string,
  description: (str?: string, ...params: Array<any>) => ?string
};

export const nullPage: SEOPageType = {
  slug: () => 'unknow-slug',
  title: () => '',
  description: () => null
};

export const SEOPages: Array<SEOPageType> = [
  {
    slug: () => 'trouver-un-club-de-rugby',
    title: () => 'Trouver un club',
    description: () =>
      'Retrouvez les clubs les plus proches de chez vous, filtrés par pratique, nombre de licenciés, horaires, compétitions et apprenez en plus sur votre futur club'
  },

  {
    slug: () => 'trouver-un-club-de-rugby/resultats-de-recherche',
    title: (search: string = '') => `Club de rugby aux alentours ${search !== '' ? 'de ' + search : ''}`,
    description: () =>
      `Retrouvez les clubs les plus proches de chez vous, filtrés par pratique, nombre de licenciés, horaires, compétitions et apprenez en plus sur votre futur club`
  },

  {
    slug: () => 'evenements',
    title: (ligue: string = '', month?: string, year?: string) =>
      `Evenement rugby ${ligue}${month && year ? ` - ${month} ${year}` : ''}`,
    description: (ligue: string = '', month?: string, year?: string) =>
      `Les évènements officiels de la ligue ${ligue} de Rugby${month && year ? ` - ${month} ${year}` : ''}.`
  },

  {
    slug: () => 'contact',
    title: () => 'Contact',
    description: () => 'La ligue répond à vos questions. À quel sujet pouvons-nous vous aider?'
  },

  {
    slug: () => 'faq',
    title: (ligue: string = '') => `Foire aux question - Ligue ${ligue} de rugby`,
    description: () =>
      `Retrouvez toutes les réponses à vos questions sur notre ligue de rugby et contactez-nous si vous celle-ci n'est pas présente dans notre liste.`
  },

  {
    slug: () => 'faq/slugTheme',
    title: (theme: string = '') => `Foire aux question - rubrique ${theme}`,
    description: (theme: string = '') =>
      `Retrouvez toutes les réponses à vos questions sur notre ligue de rugby dans la thématique ${theme}`
  },

  {
    slug: () => 'social-wall',
    title: () => `Réseaux sociaux rugby`,
    description: (ligue: string = '') => `Réseaux sociaux de la ligue ${ligue} de Rugby.`
  },

  {
    slug: () => 'recherche',
    title: (ligue: string = '') => `Recherche - Ligue ${ligue}`,
    description: () => null
  },

  {
    slug: () => 'actualites',
    title: (ligue: string = '') => `Actualités rugby ligue rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby.`
  },

  {
    slug: () => 'actualites/arbitrage',
    title: (ligue: string = '') => `Actualités arbitrage ligue rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités arbitrage de la ligue ${ligue} de Rugby.`
  },

  {
    slug: () => 'actualites/clubs_et_comites',
    title: (ligue: string = '') => `Actualités clubs rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles des clubs de la ligue ${ligue} de Rugby.`
  },

  {
    slug: () => 'actualites/ecole_rugby',
    title: (ligue: string = '') => `Actualités écoles rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles des écoles de la ligue ${ligue} de Rugby.`
  },

  {
    slug: () => 'actualites/ligue',
    title: (ligue: string = '') => `Actualités de la ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue}`
  },

  {
    slug: () => 'actualites/non-classe',
    title: (ligue: string = '') => `Actualités de la ligue ${ligue} - rubrique non classée`,
    description: (ligue: string = '') =>
      `Les actualités officielles de la ligue qui ne sont pas classés dans les autres catégories - ligue  ${ligue}`
  },

  {
    slug: () => 'actualites/rugby-a-5',
    title: (ligue: string = '') => `Actualités rugby à cinq ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby à cinq.`
  },

  {
    slug: () => 'actualites/rugby-a-7',
    title: (ligue: string = '') => `Actualités rugby à sept ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby à sept.`
  },

  {
    slug: () => 'actualites/rugby-feminin',
    title: (ligue: string = '') => `Actualités rugby féminin ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby féminin.`
  },

  {
    slug: () => 'actualites/vers-le-haut-niveau',
    title: (ligue: string = '') => `Actualités rugby haut-niveau ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} du haut-niveau.`
  },

  {
    slug: () => 'competitions',
    title: (ligue: string = '') => `Compétitions de la Ligue ${ligue}`,
    description: (ligue: string = '') => `Toutes les compétitions au sein de la ligue ${ligue}`
  }
];
